export type OrderItemModalSection = 'general' | 'products' | 'history';

export const SECTIONS: { key: OrderItemModalSection; label: string }[] = [
  { key: 'general', label: 'orders.modalHeaders.general' },
  { key: 'products', label: 'orders.modalHeaders.products' },
  { key: 'history', label: 'orders.modalHeaders.history' },
];

export type OrdersModalMode = 'view';
